// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-32426777] .field__error-message{font-size:41px !important;font-weight:bold}", ""]);
// Exports
module.exports = exports;
